<div>
    <img (click)="open(content)" [src]="'assets/ico/edit-grey.svg'" alt="translate.instant('buttons.editSelected')">
</div>
<ng-template #content let-modal>
    <form [formGroup]="form" *ngIf="form">
        <div class="modal-header light-blue">
            <div class="container-fluid">
                <div class="row modal-header-row">
                    <div class="modal-icon icon fill-white" aria-label="logo"
                        [inlineSVG]="'assets/ico/budget.svg'">
                    </div>
                    <span class="modal-title" id="modal-basic-title">{{'order.editBatch' |
                        translate}} {{selectedRows.length}}
                        <span *ngIf="selectedRows.length === 1">{{'order.budget.budget' |
                            translate}}</span>
                        <span *ngIf="selectedRows.length > 1">{{'order.budget.budgets' |
                            translate}}</span></span>
                    <div class="modal-icon icon fill-white close-icon" (click)="close()" aria-label="close"
                        [inlineSVG]="'assets/ico/close-24px.svg'"></div>
                </div>
            </div>
        </div>
        <div class="modal-body">
            <div class="fullwidth" [class.editForm]="true">
                <div class="container-fluid" [formGroup]="form">
                    <div class="row mt-2 mb-2" style="padding: 0px 15px 0px 15px;">
                        <div class="form-group col-lg">
                            <label>{{'order.type' | translate}}</label>
                            <apc-form-select formControlName="type" [items]="type" (isOpen)="fetchType()"
                                [loading]="typeLoading" (isChanged)="checkValid()">
                            </apc-form-select>
                        </div>
                        <div class="form-group col-lg">
                            <label>{{'order.department' | translate}}</label>
                            <apc-form-select formControlName="department" [items]="department"
                                (isOpen)="fetchDepartment()" [loading]="departmentLoading" [isObject]="true" (isChanged)="checkValid()">
                            </apc-form-select>
                        </div>
                        <div class="form-group col-lg">
                            <label>{{'order.budget.jobCode' | translate}}</label>
                            <apc-form-input [class]="'form-control'" formControlName="jobCode" [type]="'text'" (isChanged)="checkValid()">
                            </apc-form-input>
                        </div>

                        <div class="form-group col-lg-12 mt-4 mb-2">
                            <label>{{'order.tags' | translate}}</label>
                            <tag-input [(ngModel)]="tags" [ngModelOptions]="{standalone: true}" [modelAsStrings]="true"
                                [onAdding]="transform" (onAdd)="form.markAsDirty(); disableForm = false;"
                                (onRemove)="checkValid()"
                                [disable]="false" [onlyFromAutocomplete]="false" [allowDupes]="false">
                                <tag-input-dropdown [showDropdownIfEmpty]="false" [zIndex]="9999"
                                    [autocompleteObservable]="getTags">
                                </tag-input-dropdown>
                            </tag-input>
                            <div style="font-size: 14px;font-style: italic;color: #777777;">This is an append-only functionality. Already existing tags won't be replaced.</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="modal-footer p-0">
            <div class="container-fluid m-0 p-0">
                <button class="btn modal-btn save" (click)="bulkUpdateOrders($event)"  [disabled]="!form.dirty || disableForm">
                    {{'buttons.edit' | translate}}
                    {{selectedRows.length}}&nbsp;
                    <span *ngIf="selectedRows.length === 1">{{'order.budget.budget' |
                        translate}}</span>
                    <span *ngIf="selectedRows.length > 1">{{'order.budget.budgets' |
                        translate}}</span></button>
                <span class="btn modal-btn save" (click)="clearAll()">{{'buttons.clear' | translate }}</span>
            </div>
        </div>
    </form>
</ng-template>